module.exports = __webpack_public_path__ + "static/media/custom-10000-high.479f5aa0.svg";